import React from 'react';

const Footer = () => {
  return (
    <footer className="footer bg-gray-800 text-white p-3 text-center">
      <p className="m-0">&copy; {new Date().getFullYear()} Todos los derechos reservados.</p>
    </footer>
  );
};

export default Footer;